import classNames from 'classnames';
import Select from 'react-select';
import { FormFieldError } from './FormFieldError';
import styles from './SelectTemp.module.css';

export const SelectField = ({
    id,
    optionRenderer,
    options,
    className,
    label,
    name,
    placeholder,
    input,
    meta: { touched, error },
    ...props
}) => (
    <div
        className={classNames(styles.SelectContainerTemp, className)}
        data-testid={props['data-testid']}
    >
        <label className={styles.label} htmlFor={id}>
            {label}
        </label>
        <Select
            className={classNames('SelectContainerTemp', styles.SelectControl)}
            clearable={false}
            onChange={(value) => input.onChange(value.value)}
            onBlur={() => input.onBlur(input.value)}
            value={input.value || ''}
            optionRenderer={optionRenderer}
            options={options}
            id={id}
            name={name}
            placeholder={placeholder}
        />
        {touched && <FormFieldError message={error} />}
    </div>
);
